import { render, staticRenderFns } from "./ArchivedDocumentListScreen.vue?vue&type=template&id=17baca5c&scoped=true&"
import script from "./ArchivedDocumentListScreen.vue?vue&type=script&lang=js&"
export * from "./ArchivedDocumentListScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17baca5c",
  null
  
)

export default component.exports